import React, { useState, useEffect } from "react";
import LimitsAndTopUp from "./app_components/LimitsAndTopUp";
import { useTenantPlan } from "../hooks/useTenantPlan";

const backend_api_base_url = `${process.env.REACT_APP_SL_BE_BASE_ENV_PART}/${process.env.REACT_APP_STAGE_ENV}`;

export default function Usage() {
  // const [currentPlan, setCurrentPlan] = useState(null);
  // const [fullTenantData, setFullTenantData] = useState(null);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);

  const {
    plan: currentPlan,
    data: fullTenantData,
    loading,
    error,
    refetch,
  } = useTenantPlan();

  console.log(currentPlan,"currentPlan and  fullTenantData:", fullTenantData);


  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <div
          className="spinner"
          style={{
            width: "50px",
            height: "50px",
            border: "5px solid #f3f3f3",
            borderTop: "5px solid #667eea",
            borderRadius: "50%",
            animation: "spin 1s linear infinite",
          }}
        ></div>
        <p>Loading usage data...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          flexDirection: "column",
          gap: "20px",
          padding: "20px",
          textAlign: "center",
        }}
      >
        <div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
        <h2 style={{ color: "#dc2626", marginBottom: "8px" }}>
          Error Loading Usage Data
        </h2>
        <p style={{ color: "#666" }}>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: "10px 20px",
            backgroundColor: "#667eea",
            color: "white",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            marginTop: "16px",
          }}
        >
          Retry
        </button>
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "1200px",
        margin: "0 auto",
        padding: "20px",
        minHeight: "100vh",
      }}
    >
      <div style={{ marginBottom: "32px" }}>
        <h1
          style={{
            fontSize: "2rem",
            fontWeight: "700",
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            marginBottom: "8px",
          }}
        >
          Usage & Limits
        </h1>
        <p style={{ color: "#666", fontSize: "1rem" }}>
          Monitor your resource consumption and top up when needed
        </p>
      </div>

      <LimitsAndTopUp
        tenantPlan={currentPlan}
        fullTenantData={fullTenantData}
      />
    </div>
  );
}
